import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CsIconModule } from '@components/icon/icon.module';
import { RegimenExpiryService } from '@services/regimen-expiry-service/regimen-expiry.service';
import { ConnectionService } from '@services/connection-service';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'regimen-expired-strip',
  imports: [CsIconModule],
  templateUrl: './regimen-expired-strip.component.html',
  standalone: true
})

export class RegimenExpiredStripComponent implements OnInit {
  user: Table.User;

  constructor(
    private readonly router: Router,
    private readonly regimenExpiryService: RegimenExpiryService,
    private readonly connectionService: ConnectionService,
    private readonly eventLoggerService: EventLoggerService,
  ) {}

  ngOnInit() {
    this.user = this.connectionService.getActingUser();
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({
      bannerName: 'regimen_expired_strip',
    }));
  }

  onBannerClick() {
    this.eventLoggerService.cleverTapEvent('click', JSON.stringify({ name: 'regimen_expired_strip' }));
    this.regimenExpiryService.validateAndNavigateToConsultation(this.user);
  }
}
